import { FC } from 'react'

import { IconPlus, Button, Link } from '@sequencehq/core-components'

import { ProtectedButton } from 'lib/rbac'
import { automationsPaths } from 'Automations/router'

export const ButtonNewWorkflow: FC = () => {
  return (
    <ProtectedButton permission="org.watchtower:create">
      <Button
        data-testid="automations.newWorkflow"
        as={Link.Unstyled}
        to={automationsPaths.automationsEditor({ automationId: 'new' })}
        leadingIcon={<IconPlus />}
      >
        New workflow
      </Button>
    </ProtectedButton>
  )
}
